export default "__VITE_ASSET__CdC_cn7G__"